import { useState, useEffect, useRef } from 'react';

function useFormDraft(draftKey, initialState) {
  const storageKey = `draft:${draftKey}`;

  const [state, setState] = useState(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      if (raw) return { ...initialState, ...JSON.parse(raw) };
    } catch {}
    return initialState;
  });

  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    try {
      localStorage.setItem(
        storageKey,
        JSON.stringify(state, (_, v) =>
          v instanceof File || v instanceof Blob ? null : v
        )
      );
    } catch {}
  }, [storageKey, state]);

  const clearDraft = () => {
    localStorage.removeItem(storageKey);
    setState(initialState);
  };

  return [state, setState, clearDraft];
}

export default useFormDraft;
